import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { clearHosts } from "./hostsSlice";
import { clearGateways } from "./gatewaysSlice";

const initialState = {
  isAuth: false,
  activeComponent: "ManageGateways",
  user: {
    fullName: "",
    userType: "",
    userId: "",
    token: "",
    refreshToken: "",
    verificationCodeTimestamp: 0,
    changeEmailStep: 1,
    forgotPasswordStep: 1,
  },
};

export const logoutAndClearData = createAsyncThunk("auth/logoutAndClearData", async (_, { dispatch }) => {
  dispatch(logout());
  dispatch(clearHosts());
  dispatch(clearGateways());
});

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuth = true;
      state.user.fullName = action.payload.fullName;
      state.user.userId = action.payload.userId;
      state.user.userType = action.payload.userType;
      state.user.token = action.payload.token;
      state.user.refreshToken = action.payload.refreshToken;
    },
    updateTokens: (state, action) => {
      state.user.token = action.payload.token;
      state.user.refreshToken = action.payload.refreshToken;
    },
    logout: state => {
      state.isAuth = initialState.isAuth;
      state.user = initialState.user;
      state.activeComponent = initialState.activeComponent;
    },
    setFullName: (state, action) => {
      state.user.fullName = action.payload;
    },
    setActiveComponent: (state, action) => {
      state.activeComponent = action.payload;
    },
    setVerificationCodeTimestamp: (state, action) => {
      state.user.verificationCodeTimestamp = action.payload;
    },
    setChangeEmailStep: (state, action) => {
      state.user.changeEmailStep = action.payload;
    },
    setForgotPasswordStep: (state, action) => {
      state.user.forgotPasswordStep = action.payload;
    },
  },
});

export const {
  login,
  logout,
  setFullName,
  updateTokens,
  setActiveComponent,
  setVerificationCodeTimestamp,
  setChangeEmailStep,
  setForgotPasswordStep,
} = authSlice.actions;
export default authSlice.reducer;
